"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var TealiumHelper_1 = require("./TealiumHelper");
var AnalyticsHelper = /** @class */ (function () {
    function AnalyticsHelper(initDefaultContext, options) {
        var _a;
        this.initDefaultContext = initDefaultContext;
        this.analyticsType = ((_a = options) === null || _a === void 0 ? void 0 : _a.type) || 'gtm';
        if (this.analyticsType === 'gtm' && !window.dataLayer) {
            window.dataLayer = [];
        }
        if (this.analyticsType === 'tealium') {
            this.tealiumHelper = new TealiumHelper_1.TealiumHelper();
        }
    }
    AnalyticsHelper.prototype.loadDefaultContext = function (data) {
        if (data && data.context) {
            data.context.timestamp = Date.now();
            data.context = Object.assign(data.context, this.initDefaultContext());
        }
    };
    AnalyticsHelper.prototype.logGTMEvent = function (data) {
        window.dataLayer.push(this.orchestrateGTMData(data));
    };
    AnalyticsHelper.prototype.orchestrateGTMData = function (data) {
        var gtmData = {
            event: data.event,
            eventType: data.eventType,
            context: data.context,
        };
        return gtmData;
    };
    AnalyticsHelper.prototype.logTealiumEvent = function (data) {
        if (window.utag) {
            window.utag.link(this.orchestrateTealiumData(data));
        }
        else {
            console.warn('Tealium script has not being embedded. Please see the following URL: https://docs.tealium.com/platforms/javascript/install/#universal-tag-utag-js');
        }
    };
    AnalyticsHelper.prototype.orchestrateTealiumData = function (data) {
        var tealiumData = __assign({ tealium_event: data.event }, data.context);
        var flattenedTealiumData = this.tealiumHelper.flattenObject(tealiumData);
        return flattenedTealiumData;
    };
    AnalyticsHelper.prototype.logEvent = function (data) {
        this.loadDefaultContext(data);
        switch (this.analyticsType) {
            case 'gtm':
                this.logGTMEvent(data);
                break;
            case 'tealium':
                this.logTealiumEvent(data);
                break;
            default:
                console.warn('No analyticsType has been configured');
                break;
        }
    };
    return AnalyticsHelper;
}());
exports.AnalyticsHelper = AnalyticsHelper;
//# sourceMappingURL=AnalyticsHelper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/helpers/AnalyticsHelper.js
// module id = 729
// module chunks = 1